var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H5.05079C5.2487 4.5 5.34766 4.5 5.4273 4.53619C5.49748 4.56809 5.55695 4.61938 5.59863 4.68396C5.64592 4.75723 5.65992 4.85466 5.6879 5.04949L6.06867 7.7M6.06867 7.7L6.9149 13.8851C7.02229 14.67 7.07598 15.0625 7.26467 15.3579C7.43094 15.6182 7.66931 15.8252 7.9511 15.9539C8.27089 16.1 8.66917 16.1 9.46574 16.1H16.3504C17.1087 16.1 17.4878 16.1 17.7977 15.9643C18.0708 15.8447 18.3052 15.6519 18.4745 15.4074C18.6665 15.1301 18.7374 14.7597 18.8793 14.019L19.9441 8.45975C19.9941 8.19905 20.019 8.06869 19.9829 7.9668C19.9511 7.87742 19.8885 7.80215 19.8061 7.75441C19.7122 7.7 19.5788 7.7 19.3119 7.7H6.06867ZM10.4359 19.7C10.4359 20.1418 10.0757 20.5 9.63138 20.5C9.18708 20.5 8.8269 20.1418 8.8269 19.7C8.8269 19.2582 9.18708 18.9 9.63138 18.9C10.0757 18.9 10.4359 19.2582 10.4359 19.7ZM16.8717 19.7C16.8717 20.1418 16.5115 20.5 16.0672 20.5C15.6229 20.5 15.2628 20.1418 15.2628 19.7C15.2628 19.2582 15.6229 18.9 16.0672 18.9C16.5115 18.9 16.8717 19.2582 16.8717 19.7Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic_cart.4352248cf63ab3d9b9bcb8d864f3ec2a.svg";
export { ForwardRef as ReactComponent };